import { LINE_STYLES } from '@m1/ol-map';
import OlMap from '@m1/ol-map';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import { Draw } from 'ol/interaction';
import { Vector as VectorLayer } from 'ol/layer';
import { toLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';
import React, { useRef, useState, useMemo } from 'react';
import { RiSubtractLine } from 'react-icons/ri';
import { useDispatch, useSelector, useStore } from 'react-redux';

import styles from './index.module.scss';
import LineDrawer from '../LineDrawer';

import actions from '@/actions';
import { CommandButton } from '@/components/ui/kit/Button';
import useHandlerWithMoveCheck from '@/hooks/useHandlerWithMoveCheck';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const DrawStraightLine = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.editor.mode);
  const store = useStore();
  const [points, setPoints] = useState();
  const interaction = useRef();
  const map = OlMap.getMap();
  const { handleWithMoveCheck } = useHandlerWithMoveCheck();

  const pressed = useMemo(() => {
    return mode === 'path/line/straight';
  }, [mode]);

  useUpdateEffect(() => {
    if (!pressed) return;

    const source = new VectorSource({ wrapX: false });
    const layer = new VectorLayer({ source, style: LINE_STYLES.DRAW });
    map.addLayer(layer);

    interaction.current = new Draw({
      source,
      type: 'LineString',
      style: LINE_STYLES.DRAW,
      maxPoints: 2, // 직선 그리기 제한
    });
    interaction.current.on('drawend', drawLine);
    map.addInteraction(interaction.current);

    return () => {
      map.removeLayer(layer);
      map.removeInteraction(interaction.current);
      interaction.current = null;

      setPoints();
    };
  }, [pressed]);

  const drawLine = (e) => {
    map.removeInteraction(interaction.current);
    interaction.current = null;

    const coordinates = e.feature.getGeometry().getCoordinates();
    const nextPoints = coordinates
      // 중복 좌표 제거
      .filter((coordinate, index) => {
        const prev = JSON.stringify(coordinate);
        const next = JSON.stringify(coordinates[index + 1]);
        return prev !== next;
      })
      // 지리 좌표계 변환
      .map((coordinate) => toLonLat(coordinate));

    setPoints(nextPoints);
  };

  const toggle = () => {
    if (store.getState().mission.json.commands.length === 0) {
      notifier.error('Please add a takeoff point first.');
      return;
    }

    if (pressed) {
      dispatch(actions.editor.changeMode(null));
    } else {
      dispatch(actions.editor.changeMode('path/line/straight'));
    }
  };

  return (
    <div className={cx('container')}>
      <CommandButton
        Icon={RiSubtractLine}
        text="Straight Line"
        pressed={pressed}
        onClick={handleWithMoveCheck(toggle)}
      />
      {pressed && points && <LineDrawer points={points} onCancelOrSubmit={toggle} />}
    </div>
  );
};

export default DrawStraightLine;
